define((require) => {
    "use strict";

    var Marionette = require("marionette"),
        template   = require("../view/SalesforceCommerceWidgetPreview.tpl");

    /**
     * Product being showed in the selection of a demandware Product. It is also
     * used for the Tooltip when the widget is too small.
     *
     * @class SalesforceCommerceWidgetPreview
     */
    return Marionette.ItemView.extend({
        template: template,

        onRender: function() {
            // No deferred here, the error event can already have happened...
            var self = this,
                $img = self.$("img");

            // Add img error handler function.
            $img.on("error", () => {
                $img.hide();

                self.$(".no-image").toggleClass("hide");
            });
        },

        // Reverts the error handler from img.
        onClose: function() {
            var $img = this.$("img");

            $img.off("error");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceWidgetPreview.js